<template>
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12">
        <h2 style="font-size: 40px; font-weight: 700; line-height: 48px; " class="mb-0 mt-5">Report Analytics</h2>
    </div>
   
    <div class="col-12 d-flex" style="margin: 80px 0px;gap: 12px;">
      <div class="col-6 report-switch-tab" @click="handleChangeTabs('default')" :class="{'--active':selectedModule == 'default'}">Default Report</div>
      <div class="c0l-6 report-switch-tab" @click="handleChangeTabs('agency');"  :class="{'--active':selectedModule == 'agency'}">Agency Report</div>
    </div>


   
    <div class="col-sm-12 col-md-12 col-lg-12" v-show="selectedModule == 'default'">
      <div class="text-left pb-4 d-inline-block" v-if="!$global.globalviewmode">
        <span class="d-block mb-1">Select Company</span>
          <el-select
              class="select-primary container_filter_default_report_analytics"
              size="large"
              placeholder="Select Company"
              filterable
              default-first-option
              v-model="selects.rootSelected"
              style="width:250px"
              @change="viewRootCompany"
          >
          
              <el-option
                  v-for="option in selects.rootList"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
              >
              </el-option>
          </el-select>
    </div>
    <div class="d-inline-block">
            <div class="d-block mb-1 ml-2 select_date_container">Select Date</div>
            <div class="d-inline-block ml-2 select_date_sub_container">
                <base-input>
                  <el-date-picker
                    type="date"
                    placeholder="Date Start"
                    v-model="reportStartDate"
                    value-format="yyyy-MM-dd"
                    @change="getReportAnalytics()"
                  >
                  </el-date-picker>
                </base-input>        
            </div>
            </div>
            <div class="d-inline-block pl-2 pr-2">-</div>
            <div class="d-inline-block">
                <base-input>
                  <el-date-picker
                    type="date"
                    placeholder="Date End"
                    v-model="reportEndDate"
                    value-format="yyyy-MM-dd"
                    @change="getReportAnalytics()"
                  >
                  </el-date-picker>
                </base-input>        
            </div>
            <div class="d-inline-block">
            <base-button class="button_download_data ml-2" size="sm" style="height:40px" @click="ExportAnalyticsData()">
              <i class="fas fa-cloud-download-alt pr-2"></i> Download Data
            </base-button>
            <base-button class="button_download_unserved ml-2" size="sm" style="height:40px;" @click="ExportFailedLeadRecord()">
              <i class="fas fa-cloud-download-alt pr-2"></i> Download Unserved Leads
            </base-button>
          </div>
          <div><small>* Download Unserved Leads (includes all companies, date filter applied)</small></div>

          <div class="pt-4">&nbsp;</div>
          <div class="col-sm-12 col-md-12 col-lg-12 pt-4" style="margin-right: -15px; margin-left: -15px;">
            <div class="row">
              <skeleton-card-report-analytics v-if="isLoadingRootRevenue" :total="3"></skeleton-card-report-analytics>
              <div v-else class="col-lg-3 col-md-6" v-for="card in rootCards.filter(info => info.showCard === true)" :key="card.id">
                <stats-card
                  :title="card.title"
                  :sub-title="card.subTitle"
                  :type="card.type"
                  :icon="card.icon"
                >
                  <div slot="footer" v-html="card.footer"></div>
                </stats-card>
              </div>
            </div>
          </div>
          
          <div class="col-sm-12 col-md-12 col-lg-12" style="margin-right: -15px; margin-left: -15px; margin-top: -5px;">
            <el-divider></el-divider>
          </div>

          <div class="pt-4">&nbsp;</div>
          <div class="col-sm-12 col-md-12 col-lg-12 pb-3" style="margin-right: -15px; margin-left: -15px;">
              <div class="row">
                <skeleton-card-report-analytics v-if="isLoadingReportAnalytics"></skeleton-card-report-analytics>
                <!-- Stats Cards -->
                  <div v-else class="col-lg-3 col-md-6" v-for="card in statsCards.filter(info => info.showCard === true)" :key="card.id">
                    <stats-card
                      :title="card.title"
                      :sub-title="card.subTitle"
                      :type="card.type"
                      :icon="card.icon"
                    >
                      <div slot="footer" v-html="card.footer"></div>
                    </stats-card>
                  </div>
              </div>
           </div>

          <div class="col-sm-12 col-md-12 col-lg-12" style="margin-right: -15px; margin-left: -15px; margin-top: -5px;">
            <el-divider></el-divider>
          </div>

          <div class="pt-4">&nbsp;</div>
          <div class="col-sm-12 col-md-12 col-lg-12 pb-3" style="margin-right: -15px; margin-left: -15px;">
              <div class="row">
                <skeleton-card-report-analytics v-if="isLoadingReportAnalytics" :total="2"></skeleton-card-report-analytics>
                <!-- Stats Cards -->
                  <div v-else class="col-lg-3 col-md-6" v-for="card in statsCardsBreakdown.filter(info => info.showCard === true)" :key="card.id">
                    <stats-card-breakdown
                      :icon="card.icon"
                      :type="card.type"
                      :sub-title="card.subTitle"
                      :title="card.title"
                      :data-map="card.data"
                    ></stats-card-breakdown>
                  </div>
              </div>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-12" style="margin-right: -15px; margin-left: -15px; margin-top: -5px;">
            <el-divider></el-divider>
          </div>
          <div class="pt-4">&nbsp;</div>
          <div class="col-sm-12 col-md-12 col-lg-12 pb-3" style="margin-right: -15px; margin-left: -15px;">
            <div class="row">
              <skeleton-card-report-analytics v-if="isLoadingPixelLeadRecord" :total="4"></skeleton-card-report-analytics>
              <div v-else class="col-lg-3 col-md-6" v-for="card in statsCardPixel.filter(info => info.showCard === true)" :key="card.id">
                <stats-card-breakdown
                  :icon="card.icon"
                  :type="card.type"
                  :sub-title="card.subTitle"
                  :title="card.title"
                  :data-map="card.data"
                  :is-show-sub-title="true"
                  card-type="pixel"
                  :pixel-type="card.pixelType">
                </stats-card-breakdown>
              </div>
            </div>
          </div>

    </div>

      <!-- Agency Report Analytics table -->
      <div class="col-sm-12 col-md-12 col-lg-12" v-show="selectedModule == 'agency'">
        <div class="container__input__filter__report__analytics">
              <div class="container__input__report__analytics">
                <base-input class='mb-0'>
                  <el-input type="text" class="search-input input__report__analytics" clearable prefix-icon="el-icon-search"
                      placeholder="Search" v-model="searchQuery" aria-controls="datatables" @keyup.native.enter="searchKeyWord" @clear="searchKeyWord">
                  </el-input>
                </base-input>
              </div>
              <div class="container__filter__report__analytics">
                <div v-if="!$global.globalviewmode" class="container__select__company__agency__report">
                  <span class="d-block">Select Company</span>
                    <el-select
                        class="select-primary select__company__agency__report"
                        size="large"
                        placeholder="Select Company"
                        filterable
                        default-first-option
                        v-model="selects.rootSelected"
                        @change="viewRootCompany"
                    >
                    
                        <el-option
                            v-for="option in selects.rootList"
                            class="select-primary"
                            :value="option.id"
                            :label="option.name"
                            :key="option.id"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="d-inline-block container__date__report__analytics">
                  <div class="d-block">Select Date</div>
                    <base-input class="mb-0"
                    style="width: 100%;"
                    >
                      <el-date-picker
                        type="date"
                        placeholder="Created Date"
                        v-model="agencySelectedDate"
                        value-format="yyyy-MM-dd"
                        @change="getAgencyList('created_at', 'descending')"
                      >
                      </el-date-picker>
                    </base-input>        
                </div>
                <div class="container__button__filter__report__analytics">
                  <el-dropdown ref="dropdown" @visible-change="handleVisibleChange" class="container__button__filter__report__analytics">
                    <span>
                    <base-button class="m-0 button__filter__report__analytics" size="sm" style="height:40px" >
                        <i class="fa-solid fa-filter"></i> Filters
                    </base-button>
                    </span>

                    <el-dropdown-menu slot="dropdown" style="width: 260px;"  :class="{ 'dropdown-hidden': !dropdownVisible }" @click.native.stop>
                    <div class='ml-4 mr-4'>
                        <el-collapse value="Payment Status" style="border: none;">
                          <el-collapse-item title="Payment Status" name="Payment Status">
                              <div style="padding-left:8px;">
                              <el-checkbox v-model="filters.cardStatus.active">Stripe not connected</el-checkbox>
                              <el-checkbox v-model="filters.cardStatus.inactive">Card not connected</el-checkbox>
                              <el-checkbox v-model="filters.cardStatus.failed">Wholesale price not set</el-checkbox>
                              </div>
                          </el-collapse-item>
                        </el-collapse>
                        <el-collapse value="Campaign Status" style="border: none;">
                          <el-collapse-item title="Campaign Status" name="Campaign Status">
                              <div style="padding-left:8px;">
                              <el-checkbox v-model="filters.campaignStatus.active">Active</el-checkbox>
                              <el-checkbox v-model="filters.campaignStatus.inactive">Inactive</el-checkbox>
                              </div>
                          </el-collapse-item>
                        </el-collapse>
                        <el-collapse value="Open Api Status" style="border: none;" v-if="selects.rootSelected == $global.idsys || !selects.rootSelected">
                          <el-collapse-item title="Open Api Status" name="Open Api Status">
                              <div style="padding-left:8px;">
                              <el-checkbox v-model="filters.openApiStatus.apiMode">Developer Mode Enabled</el-checkbox>
                              <el-checkbox v-model="filters.openApiStatus.isGenerateApi">Api Key Generated</el-checkbox>
                              </div>
                          </el-collapse-item>
                        </el-collapse>
                    </div>
                    <div class='d-flex justify-content-end mr-4 mt-4'>
                        <base-button @click="applyFilters" :simple="true" size="sm">
                        Save
                        </base-button>
                    </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="container__button__export__data">
                  <base-button class="button__export__data" @click="ExportAgenciesReport()" size="sm" style="height:40px; margin: 0px;">
                    <i class="fas fa-cloud-download-alt pr-2"></i> Export Data
                  </base-button>
                </div>
              </div>
        </div>
        <div class="report-table" v-show="selectedModule == 'agency'">
           <card>
                       <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap tab-table">
                           <el-table class="table1" :highlight-current-row="false" :data="queriedData" @sort-change="sortdynamic"
                               ref="tableData" :default-sort="{prop: 'agency_name', order: 'ascending'}"
                               style="width: 525px"
                               >
                               
                               <template #empty>
                                   <i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...
                               </template>
                               
                               <el-table-column fixed prop="agency_name" min-width="200"  sortable="custom"
                                   label="Agency Name" align="left">
                                   <div slot-scope="props">
                                       {{ props.row.agency_name }}
                                   </div>
                               </el-table-column>
                               <el-table-column prop="client_name" min-width="200" sortable="custom" align="center"
                                   label="Client Name">
                                   <div slot-scope="props">{{ props.row.client_name }}</div>
                               </el-table-column>
                               <!--<el-table-column  min-width="15%"  label="E-mail">
                                       <div slot-scope="props">
                                             {{props.row.email}}
                                       </div>
                                   </el-table-column>-->
                               <!--<el-table-column  min-width="205" sortable :sort-method="sortcolumn" label="Report Type">
                                       <div slot-scope="props" v-html="setIconReportType(props.row)">
                                           
                                       </div>
                                   </el-table-column>-->
                               <el-table-column prop="agency_email" min-width="250"  align="center"
                                   label="Email">
                                   <div slot-scope="props">
                                       {{ props.row.agency_email != null ? props.row.agency_email : '-' }}
                                   </div>
                               </el-table-column>
                               <el-table-column prop="agency_phone"  min-width="175"  align="center" label="Phone">
                                       <div slot-scope="props">
                                            <span>{{props.row.agency_phone}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="clients_created"  min-width="175"   align="center" label="Clients Created">
                                       <div slot-scope="props">
                                            <span>{{props.row.clients_created}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="under_perform_campaigns_total"  min-width="250"   align="center" label="Under performing campaigns">
                                       <div slot-scope="props">
                                            <div style="cursor: pointer;" @click.stop="showModalsUnderPerform(props.row.under_perform_campaigns_details)">
                                              <div class="under_performing_campaign">
                                                <p>{{props.row.under_perform_campaigns_total}}</p>
                                                <p><i class="el-icon-info"></i></p>
                                              </div>
                                            </div>
                                       </div>
                               </el-table-column>
                               <el-table-column min-width="200"
                                    align="left" label="Connected Status">
                                   <div slot-scope="props">
                                    <div class="d-flex flex-column" style="gap: 22px;" >
                                      <div class="d-flex" style="gap: 32px;">

                                        <el-popover
                                          v-if="props.row.status_credit_card"
                                          :content="creditCardTooltip(props.row.status_credit_card)"
                                          trigger="hover"
                                          placement="top-start"
                                        >
                                        <span slot="reference">
                                           <i
                                            class="far fa-credit-card connected-status-item"
                                            :style="{ color: creditCardColor(props.row.status_credit_card) }"></i>
                                        </span>
                                        </el-popover>

                                        <el-popover
                                          v-if="props.row.status_stripe"
                                          :content="stripeTooltip(props.row.status_stripe)"
                                          trigger="hover"
                                          placement="top-start"
                                        >
                                          <span slot="reference">
                                             <i class="fa-brands fa-stripe-s connected-status-item":style="{ color: stripeColor(props.row.status_stripe) }"></i>
                                          </span>
                                        </el-popover>

                                        <el-popover
                                          v-if="props.row.status_google != null"
                                          :content="googleTooltip(props.row.status_google)"
                                          trigger="hover"
                                          placement="top"
                                        >
                                          <span slot="reference">
                                              <i class="fa-brands fa-google-drive connected-status-item":style="{ color: googleColor(props.row.status_google) }"></i>
                                           </span>
                                        </el-popover>

                                        <el-popover
                                          v-if="props.row.status_manual_bill != null"
                                          :content="manualBillTooltip(props.row.status_manual_bill)"
                                          trigger="hover"
                                          placement="top"
                                        >
                                          <span slot="reference">
                                              <i class="fa-solid fa-cash-register connected-status-item":style="{ color: manualBillColor(props.row.status_manual_bill) }"></i>
                                          </span>
                                        </el-popover>

                                      </div>
                                      <div class="d-flex" style="gap: 32px;">

                                        <el-popover
                                          v-if="props.row.status_domain != null"
                                          :content="domainTooltip(props.row.status_domain)"
                                          trigger="hover"
                                          placement="top"
                                        >
                                        <span slot="reference">
                                           <i class="fa-solid fa-link connected-status-item":style="{ color: domainColor(props.row.status_domain) }"></i>
                                        </span>
                                        </el-popover>

                                        <el-popover
                                          v-if="props.row.status_logo != null"
                                          :content="logoTooltip(props.row.status_logo)"
                                          placement="top"
                                          trigger="hover"
                                        >
                                          <span slot="reference">
                                               <i class="fa-regular fa-image connected-status-item":style="{ color: logoColor(props.row.status_logo) }"></i>
                                            </span>
                                        </el-popover>

                                        <el-popover
                                          v-if="props.row.status_smtp != null"
                                          :content="smtpTooltip(props.row.status_smtp)"
                                          placement="top"
                                          trigger="hover"
                                        >
                                           <span slot="reference">
                                               <i class="fa-regular fa-envelope connected-status-item":style="{ color: smtpColor(props.row.status_smtp) }"></i>
                                           </span>
                                        </el-popover>
                                        
                                        <el-popover
                                          v-if="props.row.status_default_price != null"
                                          :content="defaultPriceTooltip(props.row.status_default_price)"
                                          placement="top"
                                          trigger="hover"
                                        >
                                            <span slot="reference">
                                               <i class="fa-regular fa-dollar-sign connected-status-item":style="{ color: defaultPriceColor(props.row.status_default_price) }"></i>
                                            </span>
                                         </el-popover>
                                      </div>
                                      <!-- Remove v-if="props.row.company_parent == $global.idsys" div if maintain code or add new icon -->
                                      <div class="d-flex" style="gap: 32px;" v-if="props.row.company_parent == $global.idsys && props.row.api_mode == 'T'">
                                        <el-popover
                                          v-if="props.row.company_parent == $global.idsys && props.row.api_mode == 'T'"
                                          :content=tooltipApiDeveloper(props.row)
                                          placement="top"
                                          trigger="hover"
                                        >
                                         <span slot="reference">
                                               <i class="fas fa-key connected-status-item" :style="{color : colorApiDeveloper(props.row) }"></i>
                                          </span>
                                        </el-popover>
                                      </div>
                                    </div>
                                   </div>
                               </el-table-column>
                               <el-table-column prop="clients_active_credit_card"  min-width="175"  align="center" label="Clients with Active Credit Card">
                                       <div slot-scope="props">
                                            <span>{{props.row.clients_active_credit_card}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="recently_start_campaign"  min-width="140" align="center" label="Active Campaigns">
                                       <div slot-scope="props">
                                            <span>{{props.row.recently_start_campaign}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="local_active_campaign"  min-width="140" align="center" label="Site Campaigns Active">
                                       <div slot-scope="props">
                                            <span>{{props.row.local_active_campaign}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="locator_active_campaign"  min-width="170"  align="center" label="Search Campaigns Active">
                                       <div slot-scope="props">
                                            <span>{{props.row.locator_active_campaign}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="enhance_active_campaign"  min-width="180" align="center" label="Enhance Campaigns Active">
                                       <div slot-scope="props">
                                            <span>{{props.row.enhance_active_campaign}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="total_stopped_campaign"  min-width="180" align="center" label="Stop Campaigns">
                                       <div slot-scope="props">
                                            <span>{{props.row.total_stopped_campaign}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="weekly_revenue"  min-width="180" align="center" label="Total Weekly Revenue">
                                       <div slot-scope="props">
                                            <span>$ {{props.row.weekly_revenue}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="minspend_start_date"  min-width="175"  align="center" label="Min Spend Start">
                                       <div slot-scope="props">
                                            <span>{{props.row.minspend_start_date}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="account_executive"  min-width="180"   align="center" label="Account Executive">
                                       <div slot-scope="props">
                                            <span>{{props.row.account_executive != null ? props.row.account_executive : '-'}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="account_referral"  min-width="175"  align="center" label="Referral Agent">
                                       <div slot-scope="props">
                                            <span>{{props.row.account_referral != null ? props.row.account_referral : '-'}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="sales_representative"  min-width="175"  align="center" label="Sales Agent">
                                       <div slot-scope="props">
                                            <span>{{props.row.sales_representative != null ? props.row.sales_representative : '-'}}</span>
                                       </div>
                               </el-table-column>
                              
                               <el-table-column prop="created_on"  min-width="175" sortable="custom"  align="center" label="Created On">
                                       <div slot-scope="props">
                                            <span> {{props.row.created_on}}</span>
                                       </div>
                               </el-table-column>
                           </el-table>
                       </div>
           <template #footer>
              <div class="float-right">
                <div class="pt-3">
                      <p class="card-category">
                          Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }}
                          entries
                      </p>
                </div>
  
                <base-pagination
                 class="pagination-no-border pt-4"
                 v-model="pagination.currentPage"
                 :per-page="pagination.perPage"
                 :total="pagination.total"
                 @input="changePage"
                 >
                </base-pagination>
                      
              </div>
           </template>
        </card>
      </div>
    </div>
    <modal v-if="selectedModule == 'agency'" :show.sync="isCampaignModelOpen" bodyClasses='create-campaign-modal-body under-performing-campaigns'
            footerClasses="border-top p-2">
                <h3 slot="header" class="title title-up">Under Performing campaigns of dummy agency</h3>
                <div class="row">
                  <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap tab-table mt-5 mb-2">
                           <el-table class="table2" :highlight-current-row="false" :data="campaignsData"
                               ref="tableDataUnderPerformCampaign"
                               height="250"
                               style="width: 525px;"
                               >
                               
                               <!-- <template #empty>
                                   <i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...
                               </template> -->
                               
                               <el-table-column fixed prop="company_name" min-width="200"  sortable="custom"
                                   label="Company Name" align="left">
                                   <div slot-scope="props">
                                       {{ props.row.company_name }}
                                   </div>
                               </el-table-column>
                               <el-table-column prop="campaign_name" min-width="200" sortable="custom" align="center"
                                   label="Campaign Name">
                                   <div slot-scope="props">{{ props.row.campaign_name }}</div>
                               </el-table-column>
                              
                               <el-table-column prop="leadspeek_api_id" min-width="250"  align="center"
                                   label="Campaign ID">
                                   <div slot-scope="props">
                                       {{ props.row.leadspeek_api_id }}
                                   </div>
                               </el-table-column>
                               <el-table-column prop="total_leads"  min-width="175"  align="center" label="Total leads">
                                       <div slot-scope="props">
                                            <span>{{props.row.total_leads}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="lp_limit_leads"  min-width="175"   align="center" label="Requested Leads">
                                       <div slot-scope="props">
                                            <span>{{props.row.lp_limit_leads}}</span>
                                       </div>
                               </el-table-column>
                               <el-table-column prop="created_on"  min-width="250"   align="center" label="Created at">
                                       <div slot-scope="props">
                                            <div>{{props.row.created_on}}</div>
                                       </div>
                               </el-table-column>
                               
                           </el-table>
                       </div>
                </div>
    </modal>
  </div>
</template>

<script>
import StatsCard from 'src/components/Cards/StatsCard';
import StatsCardBreakdown from 'src/components/Cards/StatsCardBreakdown';
import SkeletonCardReportAnalytics from 'src/components/Pages/ReportAnalytics/SkeletonCardReportAnalytics'
import { DatePicker, Select, Option,Checkbox,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem,CollapseItem,Collapse,Divider} from 'element-ui';
import { BasePagination,Modal } from 'src/components';
import { downloadFileInBackground } from '../../../../helpers/downloadFile'

export default {
    components: {
        [DatePicker.name]: DatePicker,
        StatsCard,
        StatsCardBreakdown,
        [Option.name]: Option,
        [Select.name]: Select,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BasePagination,
        Modal,
        SkeletonCardReportAnalytics,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Collapse.name]: Collapse,
        [Checkbox.name]: Checkbox,
        [CollapseItem.name]: CollapseItem,
        [Divider.name]: Divider
    },
    computed:{
      queriedData(){
        let result = this.tableData;
        if (this.searchedData.length > 0) {
            result = this.searchedData;
        }
        return result
      },
      to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        },
    },
    data() {
        return {
          dropdownVisible: false,
          filters:{
                cardStatus:{
                    show:false,
                    active:false,
                    failed:false,
                    inactive:false
                },
                campaignStatus:{
                    show:false,
                    active:false,
                    inactive:false,
                },
                openApiStatus:{
                    show:false,
                    apiMode:false,
                    isGenerateApi:false,
                },
            },
          campaignsData:[],
          selectedModule:'default',
          isCampaignModelOpen: false,
          pagination: {
                perPage: 10,
                currentPage: 1,
                //perPageOptions: [5, 10, 25, 50],
                total: 0,
                from: 0,
                to: 0,
            },
            
            agencySelectedDate: '',
            reportStartDate: '',
            reportEndDate: '',
            activeCompanyID: '',
            activeCampaignID: '',
            selects: {
              rootList: [],
              rootSelected: "",
            },
            rootCards: [
                {
                    id: '0',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'Exact Match Marketing Revenue',
                    showCard:true,
                },
                {
                    id: '1',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'Internet Dominator Revenue',
                    showCard:true,
                },
                {
                    id: '2',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'Go Mobile Leads Revenue',
                    showCard:true,
                },
            ],
            statsCards: [
                {
                    id: '0',
                    title: '0 Fire(s)',
                    subTitle: 'Total Fires',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Tower Data Pixel Fire',
                    showCard:true,
                },
                {
                    id: '1',
                    title: '0 Call(s)',
                    subTitle: 'Total Calls',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Tower Data Postal API',
                    showCard:true,
                },
                {
                    id: '2',
                    title: '0 Call(s)',
                    subTitle: 'Total Calls',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful BIG BDM MD5',
                    showCard:true,
                },
                    
                {
                    id: '3',
                    title: '0 Call(s)',
                    subTitle: 'Total Calls',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful BIG BDM PII',
                    showCard:true,
                },
                {
                    id: '4',
                    title: '0 Call(s)',
                    subTitle: 'Total Calls',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful WattData',
                    showCard:true,
                },
                {
                    id: '5',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Site ID BIG BDM Identified',
                    showCard:true,
                },
                {
                    id: '6',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Site ID WattData Identified',
                    showCard:true,
                },
                {
                    id: '7',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Site ID BIG DBM Local Identified',
                    showCard:true,
                },
                {
                    id: '8',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Site ID WattData Local Identified',
                    showCard:true,
                },
                {
                    id: '9',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Site ID Serve Data Total',
                    showCard:true,
                },
                {
                    id: '10',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Site ID Serve Data BIG DBM',
                    showCard:true,
                },
                {
                    id: '11',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Site ID Serve Data WATT DATA',
                    showCard:true,
                },
                {
                    id: '12',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Site ID Serve Data BIG DBM Local',
                    showCard:true,
                },
                {
                    id: '13',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Site ID Serve Data WATT DATA Local',
                    showCard:true,
                },
                {
                    id: '14',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'Site ID serve revenue',
                    showCard:true,
                },
                {
                    id: '15',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Search ID serve data',
                    showCard:false,
                },
                {
                    id: '16',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'Search ID serve revenue',
                    showCard:false,
                },
                {
                    id: '17',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Enhance ID Serve Data Total',
                    showCard:true,
                },
                {
                    id: '18',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'Enhance ID serve revenue',
                    showCard:true,
                },
                {
                    id: '19',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful B2B ID serve data',
                    showCard:true,
                },
                {
                    id: '20',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'B2B ID serve revenue',
                    showCard:true,
                },
                {
                    id: '21',
                    title: '0 Blocked',
                    subTitle: 'Total Blocked',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'Blocked by Truelist',
                    showCard:true,
                },
                {
                    id: '22',
                    title: '0 Blocked',
                    subTitle: 'Total Blocked',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'Blocked by Location Lock',
                    showCard:true,
                },
                {
                    id: '23',
                    title: '0 Active',
                    subTitle: 'Total Active',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Site ID active campaign',
                    showCard:true,
                },
                {
                    id: '24',
                    title: '0 Active',
                    subTitle: 'Total Active',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Search ID active campaign',
                    showCard:false,
                },
                {
                    id: '25',
                    title: '0 Active',
                    subTitle: 'Total Active',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Enhance ID active campaign',
                    showCard:true,
                },
                {
                    id: '26',
                    title: '0 Active',
                    subTitle: 'Total Active',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'B2B ID active campaign',
                    showCard:true,
                },
                {
                    id: '27',
                    title: '0 Lead(s)',
                    subTitle: 'Total Leads',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'BIG BDM MD5 Requested Enhance',
                    showCard:true,
                },
                {
                    id: '28',
                    title: '0 Lead(s)',
                    subTitle: 'Total Leads',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'BIG BDM MD5 Delivered Enhance',
                    showCard:true,
                },
                {
                    id: '29',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Enhance ID BIG BDM Identified',
                    showCard:true,
                },
                {
                    id: '30',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Enhance ID Serve Data BIG DBM',
                    showCard:true,
                },
                {
                    id: '31',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Enhance ID BIG DBM Local Identified',
                    showCard:true,
                },
                {
                    id: '32',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Enhance ID Serve Data BIG DBM Local',
                    showCard:true,
                },
                {
                    id: '33',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Enhance ID WattData Identified',
                    showCard:true,
                },
                {
                    id: '34',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Enhance ID Serve Data WATT DATA',
                    showCard:true,
                },
                {
                    id: '35',
                    title: '0 Identified',
                    subTitle: 'Total Identified',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Enhance ID WattData Local Identified',
                    showCard:true,
                },
                {
                    id: '36',
                    title: '0 Serve(s)',
                    subTitle: 'Total Serves',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Successful Enhance ID Serve Data WATT DATA Local',
                    showCard:true,
                },
                {
                    id: '37',
                    title: '0 Lead(s)',
                    subTitle: 'Total Remaining',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'BIG BDM MD5 Remaining Leads Enhance',
                    showCard:true,
                },

                
                {
                    id: '38',
                    title: '0 Lead(s)',
                    subTitle: 'Total Leads',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'BIG BDM MD5 Requested B2B',
                    showCard:true,
                },
                {
                    id: '39',
                    title: '0 Lead(s)',
                    subTitle: 'Total Leads',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'BIG BDM MD5 Delivered B2B',
                    showCard:true,
                },
                {
                    id: '40',
                    title: '0 Lead(s)',
                    subTitle: 'Total Remaining',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'BIG BDM MD5 Remaining Leads B2B',
                    showCard:true,
                },


                {
                    id: '41',
                    title: '0 Failed',
                    subTitle: 'Total Failed',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'ThirdParty Failed Get Data',
                    showCard:true,
                },



                {
                    id: '42',
                    title: '0 Failed',
                    subTitle: 'Total Failed',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'Failed Get Data BIG BDM MD5',
                    showCard:false,
                },
                {
                    id: '43',
                    title: '0 Failed',
                    subTitle: 'Total Failed',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'Failed Get Data TOWER DATA',
                    showCard:false,
                },
                {
                    id: '44',
                    title: '0 Failed',
                    subTitle: 'Total Failed',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'Failed Get Data BIG DBM PII',
                    showCard:false,
                },
                {
                    id: '45',
                    title: '0 Failed',
                    subTitle: 'Total Failed',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'Failed Get Data WattData MD5',
                    showCard:false,
                },
                {
                    id: '46',
                    title: '0 Failed',
                    subTitle: 'Total Failed',
                    type: 'primary',
                    icon: 'fas fas fa-do-not-enter',
                    footer: 'Failed Get Data WattData PII',
                    showCard:false,
                },
                {
                    id: '47',
                    title: '0 Active',
                    subTitle: 'Total Active',
                    type: 'primary',
                    icon: 'fas fa-sort-amount-up',
                    footer: 'Simplifi active campaign',
                    showCard: true,
                },
                {
                    id: '48',
                    title: '$0',
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: 'Simplifi revenue',
                    showCard:true,
                },
                {
                  id: '49',
                  title: '0 Impression(s)',
                  subTitle: 'Total Impressions',
                  type: 'primary',
                  icon: 'fas fa-chart-bar',
                  footer: 'Simplifi impressions',
                  showCard:true,
                },

            ],

          statsCardsBreakdown:[
            {
              id: '1',
              data: {
                0: {
                  valid: 0,
                  invalid: 0,
                  catch_all: 0,
                  unknown: 0,
                  spamtrap: 0,
                  abuse: 0,
                  do_not_mail: 0,
                  total: 0,
                },
              },
              title:'0 Email(s)',
              subTitle: 'ZeroBounce Details',
              type: 'primary',
              icon: 'fas fa-sort-amount-up',
              footer: 'Zero Bounce Total',
              showCard:true,
            },
            {
              id: '2',
              data: {
                0: {
                  total: 0,
                  ok: 0,
                  email_invalid: 0,
                  risky: 0,
                  unknown: 0,
                  accept_all: 0,
                }
              },
              title: '0 Email(s)',
              subTitle: 'Truelist Details',
              type: 'primary',
              icon: 'fas fa-check-double',
              footer: 'Truelist Total',
              showCard: true,
            },
          ],

          // statsCardsBreakdown:[
          //   {
          //     id: '1',
          //     data: {
          //       valid: 1,
          //       invalid: 2,
          //       catch_all: 3,
          //       unknown: 4,
          //       spamtrap: 5,
          //       abuse: 6,
          //       do_not_mail: 7,
          //       total: 8,
          //     },
          //     title:'11 Email(s)',
          //     subTitle: 'ZeroBounce Details',
          //     type: 'primary',
          //     icon: 'fas fa-sort-amount-up',
          //     footer: 'Zero Bounce Total',
          //     showCard:true,
          //   },
          //   {
          //     id: '2',
          //     data: {},
          //     title: '12 Email(s)',
          //     subTitle: 'Truelist Details',
          //     type: 'primary',
          //     icon: 'fas fa-check-double',
          //     footer: 'Truelist Total',
          //     showCard: true,
          //   },
          // ],

          statsCardPixel: [
            {
              id: '1',
              data: {
                all_country: {
                  running: 0,
                  stopped: 0,
                  paused: 0,
                  paused_run: 0,
                  total_all: 0
                },
                us_country: {
                  running: 0,
                  stopped: 0,
                  paused: 0,
                  paused_run: 0,
                  total_all: 0
                },
                non_us_country: {
                  running: 0,
                  stopped: 0,
                  paused: 0,
                  paused_run: 0,
                  total_all: 0
                },
              },
              title:'0 Visitor(s)',
              subTitle: 'Pixel Impressions (All Visitors)',
              type: 'primary',
              icon: 'fas fa-sort-amount-up',
              pixelType: 'pixel_impressions_all_visitors',
              showCard:true,
            },
            {
              id: '2',
              data: {
                all_country: {
                  running: 0,
                  stopped: 0,
                  paused: 0,
                  paused_run: 0,
                  total_all: 0
                },
                us_country: {
                  running: 0,
                  stopped: 0,
                  paused: 0,
                  paused_run: 0,
                  total_all: 0
                },
                non_us_country: {
                  running: 0,
                  stopped: 0,
                  paused: 0,
                  paused_run: 0,
                  total_all: 0
                },
              },
              title:'0 Visitor(s)',
              subTitle: 'Pixel Impressions (Unique Visitors)',
              type: 'primary',
              icon: 'fas fa-sort-amount-up',
              pixelType: 'pixel_impressions_unique_visitors',
              showCard:true,
            },
            {
              id: '3',
              data: {
                all_country: {
                  total: 0
                },
                us_country: {
                  total: 0
                },
                non_us_country: {
                  total: 0
                },
              },
              title:'0 Visitor(s)',
              subTitle: 'Pixel Visitor ID Empty',
              type: 'primary',
              icon: 'fas fa-sort-amount-up',
              pixelType: 'pixel_visitor_id_empty',
              showCard:true,
            },
            {
              id: '4',
              data: {
                all_country: {
                  total: 0
                },
                us_country: {
                  total: 0
                },
                non_us_country: {
                  total: 0
                },
              },
              title:'0 Received',
              subTitle: 'Pixel Feedback Received',
              type: 'primary',
              icon: 'fas fa-sort-amount-up',
              pixelType: 'pixel_feedback_received',
              showCard:true,
            },
          ],

          // statsCardPixel: [
          //   {
          //     id: '1',
          //     cardType: 'breakdown',
          //     data: {
          //       running: 0,
          //       stopped: 0,
          //       paused: 0,
          //       paused_run: 0,
          //     },
          //     title:'0 Visitor(s)',
          //     subTitle: 'Pixel Impressions (All Visitors)',
          //     type: 'primary',
          //     icon: 'fas fa-sort-amount-up',
          //     showCard:true,
          //   },
          //   {
          //     id: '2',
          //     cardType: 'breakdown',
          //     data: {
          //       running: 0,
          //       stopped: 0,
          //       paused: 0,
          //       paused_run: 0,
          //     },
          //     title:'0 Visitor(s)',
          //     subTitle: 'Pixel Impressions (Unique Visitors)',
          //     type: 'primary',
          //     icon: 'fas fa-sort-amount-up',
          //     showCard:true,
          //   },
          //   {
          //     id: '3',
          //     cardType: 'card',
          //     title: '0 Visitor(s)',
          //     subTitle: 'Total Visitors',
          //     type: 'primary',
          //     icon: 'fas fa-sort-amount-up',
          //     footer: 'Pixel Visitor ID Empty',
          //     showCard:true,
          //   },
          //   {
          //     id: '4',
          //     cardType: 'card',
          //     title: '0 Received',
          //     subTitle: 'Total Received',
          //     type: 'primary',
          //     icon: 'fas fa-sort-amount-up',
          //     footer: 'Pixel Feedback Received',
          //     showCard:true,
          //   },
          // ],

          tableDataOri:[],
          tableData: [],
          searchedData: [],
          searchQuery: '',
          currSortBy: '',
          currOrderBy: '',
          isLoadingReportAnalytics: false,
          isLoadingRootRevenue: false,
          isLoadingPixelLeadRecord: false,
          tableDataUnderPerformCampaign:[],
        };
    },
    methods: {
      handleChangeTabs(tab){
        this.selectedModule = tab;
        if(tab == 'agency'){
          this.getAgencyList('created_at', 'descending')
        } else {
          this.getReportAnalytics()
        }
      },
      showModalsUnderPerform(campaignIds){
        this.getUndePerformCampaign(campaignIds)
        this.isCampaignModelOpen = true;
      },
      creditCardTooltip(status) {
        switch (status) {
          case "active":
            return "Credit Card Connected";
          case "inactive":
            return "Credit Card Inactive";
          case "failed":
            return "Credit Card Failed";
          default:
            return "No Credit Card Status";
        }
      },
      creditCardColor(status) {
        switch (status) {
          case "active":
            return "green";
          case "inactive":
            return "gray";
          case "failed":
            return "red";
          default:
            return "gray";
        }
      },
      stripeTooltip(status) {
        switch (status) {
          case "completed":
            return "Stripe Connected";
          case "inverification":
            return "Agency in Verification";
          case "pending":
            return "Agency need to complete the registration";
          case "not_registered":
            return "Agency Not Registered";
          default:
            return "No Credit Card Status";
        }
      },
      stripeColor(status) {
        switch (status) {
          case "completed":
            return "green";
          case "inverification":
            return "orange";
          case "pending":
            return "yellow";
          case "not_registered":
            return "gray";
          case "error_check_status":
            return "red";
          default:
            return "gray";
        }
      },
      googleTooltip(status) {
        switch (status) {
          case true:
            return "Google Connected";
          case false:
            return "Not Connected";
          default:
            return "Not Connected";
        }
      },
      googleColor(status) {
        switch (status) {
          case true:
            return "green";
          case false:
            return "gray";
          default:
            return "gray";
        }
      },
      manualBillTooltip(status) {
        switch (status) {
          case true:
            return "Wholesale pricing saved (or Direct Pay Enabled)";
          case false:
            return "Wholesale pricing not saved (or Direct Pay Disabled)";
          default:
            return "Wholesale pricing not saved (or Direct Pay Disabled)";
        }
      },
      manualBillColor(status) {
        switch (status) {
          case true:
            return "yellow";
          case false:
            return "gray";
          default:
            return "gray";
        }
      },
      domainTooltip(status) {
        switch (status) {
          case true:
            return "URL Customized";
          case false:
            return "URL not set";
          default:
            return "URL not set";
        }
      },
      domainColor(status) {
        switch (status) {
          case true:
            return "green";
          case false:
            return "gray";
          default:
            return "gray";
        }
      },
      logoTooltip(status) {
        switch (status) {
          case true:
            return "Logo Updated";
          case false:
            return "Logo not set";
          default:
            return "Logo not set";
        }
      },
      logoColor(status) {
        switch (status) {
          case true:
            return "green";
          case false:
            return "gray";
          default:
            return "gray";
        }
      },
      smtpTooltip(status) {
        switch (status) {
          case true:
            return "SMTP Established";
          case false:
            return "SMTP not Established";
          default:
            return "SMTP not Established";
        }
      },
      smtpColor(status) {
        switch (status) {
          case true:
            return "green";
          case false:
            return "gray";
          default:
            return "gray";
        }
      },
      defaultPriceTooltip(status) {
        switch (status) {
          case true:
            return "Default price set";
          case false:
            return "Default price not set";
          default:
            return "Default price not set";
        }
      },
      defaultPriceColor(status) {
        switch (status) {
          case true:
            return "green";
          case false:
            return "red";
          default:
            return "red";
        }
      },
      getUndePerformCampaign(campaignIds){
        this.campaignsData = [];
        $('.table2 .el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
        this.$store.dispatch('GetUnderPerformCampaigns', {
             campaignIds: campaignIds,
             selectedDate: this.agencySelectedDate,
            }).then(response => {
              if (response.campaigns.length > 0) {
                this.campaignsData = response.campaigns
              } else {
                $('.table2 .el-table__empty-text').html('No Data');
              }
            },error => {
              this.campaignsData = [];
              $('.table2 .el-table__empty-text').html('No Data');
            });

      },
      getAgencyList(sortby,order){
            var _sortby = '';
            var _order = '';
            var _searchkey = '';
            
            if (typeof(sortby) != 'undefined') {
                _sortby = sortby;
            }
            if (typeof(order) != 'undefined') {
                _order = order;
            }

            if (this.searchQuery != '') {
                _searchkey = this.searchQuery;
            }            

            /** GET AGENCY LIST */
            this.tableData = [];
            $('.table1 .el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
            this.$store.dispatch('GetAgencyList', {
                groupCompanyID: this.selects.rootSelected,
                sortby: _sortby,
                order: _order,
                searchkey: _searchkey,
                selectedDate: this.agencySelectedDate,
                page:this.pagination.currentPage,
                cardStatus: this.filters.cardStatus,
                campaignStatus: this.filters.campaignStatus,
                openApiStatus: this.filters.openApiStatus,
            }).then(response => {
                this.pagination.currentPage = response.agencies.current_page? response.agencies.current_page : 1
                this.pagination.total = response.agencies.total ?response.agencies.total : 0
                this.pagination.lastPage = response.agencies.last_page ? response.agencies.last_page : 0
                this.pagination.from = response.agencies.from ? response.agencies.from : 0
                this.pagination.to = response.agencies.to ? response.agencies.to : 0
                
                
                
                for(let i=0;i<response.agencies.data.length;i++) {
                    if (response.agencies.data[i].agency_phone == '' || response.agencies.data[i].agency_phone == null) {
                      response.agencies.data[i].agency_phone = '000-000-0000';
                    }
                }
                this.tableData = response.agencies.data

                if (this.tableData.length == 0) {
                    $('.table1 .el-table__empty-text').html('No Data');
                }
            },error => {
              this.tableData = [];
              $('.table1 .el-table__empty-text').html('No Data');
            });
            /** GET AGENCY LIST */
      },
      sortdynamic(column,prop,order) { 
            this.currSortBy = column.prop;
            this.currOrderBy = column.order;
            this.getAgencyList(this.currSortBy,this.currOrderBy);
      },
      searchKeyWord() {
            this.pagination.currentPage = 1;
            this.getAgencyList(this.currSortBy,this.currOrderBy);
      },
      applyFilters(event){
            event.stopPropagation(); // Prevent click propagation
            this.getAgencyList(this.currSortBy, this.currOrderBy)
            this.dropdownVisible = false;
      },
      changePage(event){
            //console.log(this.pagination,event)
            this.getAgencyList(this.currSortBy, this.currOrderBy)
      },
      handleVisibleChange(visible) {            
            this.dropdownVisible = visible;
        },
        ExportAnalyticsData() {
          var reportStart = this.reportStartDate;
          var reportEnd = this.reportEndDate;
          var _companyid = '';
          var _campaignid = '';

          if (this.activeCompanyID != '') {
              _companyid = '/' + this.activeCompanyID;
          }

          if (this.activeCampaignID != '' && _companyid != '') {
              _campaignid = '/' + this.activeCampaignID;
          }

          const url = process.env.VUE_APP_DATASERVER_URL + '/configuration/report-analytics/download/' + reportStart + '/' + reportEnd + _companyid + _campaignid;
          downloadFileInBackground(url, 'report-analytics.csv')
        },
        ExportFailedLeadRecord() {
          var reportStart = this.reportStartDate;
          var reportEnd = this.reportEndDate;

          const url = `${process.env.VUE_APP_DATASERVER_URL}/configuration/failed-lead-record/download/${reportStart}/${reportEnd}`;
          downloadFileInBackground(url, 'unserved-leads.csv')
        },
        ExportAgenciesReport() {
          let CompanyRootId = this.selects.rootSelected;
          let agencyStatus = this.filters.cardStatus; // Misalnya objek { active: false, inactive: false, show: false }
          let campaignStatus = this.filters.campaignStatus; 
          let openApiStatus = this.filters.openApiStatus; 
          let selectedDate = this.agencySelectedDate;

          // Convert objek ke JSON string
          let agencyStatusString = JSON.stringify(agencyStatus); 
          let campaignStatusString = JSON.stringify(campaignStatus);
          let openApiStatusString = JSON.stringify(openApiStatus);

          let _groupCompanyID = "/all";
          let _sortby = "";
          let _order = "";
          let _searchkey = "";

          if (CompanyRootId != "" && typeof CompanyRootId != "undefined") {
              _groupCompanyID = "/" + CompanyRootId;
          }

          if (typeof this.currSortBy != "undefined" && this.currSortBy != "") {
              _sortby = "/" + this.currSortBy;
          }

          if (typeof this.currOrderBy != "undefined" && this.currOrderBy != "") {
              if (_sortby != "") {
                  _order = "/" + this.currOrderBy;
              }
          }

          if (typeof this.searchQuery != "undefined" && this.searchQuery != "") {
              if (_sortby == "") {
                  _searchkey = "/created_at/descending/" + this.searchQuery;
              } else {
                  _searchkey = "/" + this.searchQuery;
              }
            }

          const isRootEmm = this.$global.rootcomp ? `&idsys=${this.$global.idsys}` : '';

          const url = `${process.env.VUE_APP_DATASERVER_URL}/configuration/agencies-report/download`
              + _groupCompanyID
              + _sortby
              + _order
              + _searchkey
              + `?AgencyStatus=${encodeURIComponent(agencyStatusString)}&CampaignStatus=${encodeURIComponent(campaignStatusString)}&SelectedDate=${selectedDate}&OpenApiStatus=${encodeURIComponent(openApiStatusString)}${isRootEmm}`;

          downloadFileInBackground(url, 'agencies-report.csv')
      },
        viewRootCompany() {
          if(!this.selects.rootSelected){
            // dont remove this code
          } else if (this.selects.rootSelected != this.$global.idsys){
            this.filters.openApiStatus.apiMode = false;
            this.filters.openApiStatus.isGenerateApi = false;
          }

          if(this.selectedModule == 'agency'){
            this.getAgencyList('created_at', 'descending')
          } else {
            this.getReportAnalytics();
          }
        },
        getRootList() {
          this.$store.dispatch('getRootList').then(response => {
            if (this.selects.rootList.length == 0) {
              this.selects.rootList = response.params
              this.selects.rootList.unshift({'id':'','name':'View All'});
              // this.selects.rootSelected = this.$global.idsys;
              this.selects.rootSelected = '';
              this.getReportAnalytics();
            }
          },error => {
              
          });
        },
        resetCardBreakdown() {
          this.statsCardsBreakdown[0].title = '0 Email(s)';
          this.statsCardsBreakdown[0].data = {
            0: {
              valid: 0,
              invalid: 0,
              catch_all: 0,
              unknown: 0,
              spamtrap: 0,
              abuse: 0,
              do_not_mail: 0,
              total: 0,
            }
          };
          this.statsCardsBreakdown[1].title = '0 Email(s)';
          this.statsCardsBreakdown[1].data = {
            0: {
              total: 0,
              ok: 0,
              email_invalid: 0,
              risky: 0,
              unknown: 0,
              accept_all: 0,
            }
          };
        },
        resetCardPixel() {
          // all regional
          this.statsCardPixel[0].data['all_country'].running = 0;
          this.statsCardPixel[0].data['all_country'].stopped = 0;
          this.statsCardPixel[0].data['all_country'].paused = 0;
          this.statsCardPixel[0].data['all_country'].paused_run = 0;
          this.statsCardPixel[0].data['all_country'].total_all = 0;
          // us regional
          this.statsCardPixel[0].data['us_country'].running = 0;
          this.statsCardPixel[0].data['us_country'].stopped = 0;
          this.statsCardPixel[0].data['us_country'].paused = 0;
          this.statsCardPixel[0].data['us_country'].paused_run = 0;
          this.statsCardPixel[0].data['us_country'].total_all = 0;
          // non us regional
          this.statsCardPixel[0].data['non_us_country'].running = 0;
          this.statsCardPixel[0].data['non_us_country'].stopped = 0;
          this.statsCardPixel[0].data['non_us_country'].paused = 0;
          this.statsCardPixel[0].data['non_us_country'].paused_run = 0;
          this.statsCardPixel[0].data['non_us_country'].total_all = 0;
          // title
          this.statsCardPixel[0].title = '0 Visitor(s)';


          // all regional
          this.statsCardPixel[1].data['all_country'].running = 0;
          this.statsCardPixel[1].data['all_country'].stopped = 0;
          this.statsCardPixel[1].data['all_country'].paused = 0;
          this.statsCardPixel[1].data['all_country'].paused_run = 0;
          this.statsCardPixel[1].data['all_country'].total_all = 0;
          // us regional
          this.statsCardPixel[1].data['us_country'].running = 0;
          this.statsCardPixel[1].data['us_country'].stopped = 0;
          this.statsCardPixel[1].data['us_country'].paused = 0;
          this.statsCardPixel[1].data['us_country'].paused_run = 0;
          this.statsCardPixel[1].data['us_country'].total_all = 0;
          // non us regional
          this.statsCardPixel[1].data['non_us_country'].running = 0;
          this.statsCardPixel[1].data['non_us_country'].stopped = 0;
          this.statsCardPixel[1].data['non_us_country'].paused = 0;
          this.statsCardPixel[1].data['non_us_country'].paused_run = 0;
          this.statsCardPixel[1].data['non_us_country'].total_all = 0;
          // title
          this.statsCardPixel[1].title = '0 Visitor(s)';


          // all regional
          this.statsCardPixel[2].data['all_country'].total = 0;
          // us regional
          this.statsCardPixel[2].data['us_country'].total = 0;
          // non us regional
          this.statsCardPixel[2].data['non_us_country'].total = 0;
          // title
          this.statsCardPixel[2].title = '0 Visitor(s)';


          // all regional
          this.statsCardPixel[3].data['all_country'].total = 0;
          // us regional
          this.statsCardPixel[3].data['us_country'].total = 0;
          // non us regional
          this.statsCardPixel[3].data['non_us_country'].total = 0;
          // title
          this.statsCardPixel[3].title = '0 Received';
        },
        resetCardValue() {
          this.statsCards[0].title = '0 Fire(s)';
          this.statsCards[1].title = '0 Call(s)';
          //this.statsCards[2].title = total_endato + ' Call(s)';
          //this.statsCards[3].title = total_md5 + ' Call(s)';
          this.statsCards[2].title = '0 Call(s)';
          this.statsCards[3].title = '0 Call(s)';
          this.statsCards[4].title = '0 Call(s)';
          this.statsCards[5].title = '0 Identified';
          this.statsCards[6].title = '0 Identified';
          this.statsCards[7].title = '0 Identified';
          this.statsCards[8].title = '0 Identified';
          this.statsCards[9].title = '0 Serve(s)';
          this.statsCards[10].title = '0 Serve(s)';
          this.statsCards[11].title = '0 Serve(s)';
          this.statsCards[12].title = '0 Serve(s)';
          this.statsCards[13].title = '0 Serve(s)';
          this.statsCards[14].title = '$0';
          this.statsCards[15].title = '0 Serve(s)';
          this.statsCards[16].title = '$0';
          this.statsCards[17].title = '0 Serve(s)';
          this.statsCards[18].title = '$0';
          this.statsCards[19].title = '0 Serve(s)';
          this.statsCards[20].title = '$0';
          this.statsCards[21].title = '0 Blocked';
          this.statsCards[22].title = '0 Blocked';
          this.statsCards[23].title = '0 Active';
          this.statsCards[24].title = '0 Active';
          this.statsCards[25].title = '0 Active';
          this.statsCards[26].title = '0 Active';

          this.statsCards[27].title = '0 Lead(s)';
          this.statsCards[28].title = '0 Lead(s)';
          this.statsCards[29].title = '0 Identified';
          this.statsCards[30].title = '0 Serve(s)';
          this.statsCards[31].title = '0 Identified';
          this.statsCards[32].title = '0 Serve(s)';
          this.statsCards[33].title = '0 Identified';
          this.statsCards[34].title = '0 Serve(s)';
          this.statsCards[35].title = '0 Identified';
          this.statsCards[36].title = '0 Serve(s)';
          this.statsCards[37].title = '0 Lead(s)';

          this.statsCards[38].title = '0 Lead(s)';
          this.statsCards[39].title = '0 Lead(s)';
          this.statsCards[40].title = '0 Lead(s)';
          
          this.statsCards[41].title = '0 Failed';
          this.statsCards[42].title = '0 Failed';
          this.statsCards[43].title = '0 Failed';
          this.statsCards[44].title = '0 Failed';
          this.statsCards[45].title = '0 Failed';
          this.statsCards[46].title = '0 Failed';
          this.statsCards[47].title = '0 Active';
          this.statsCards[48].title = '$0';
          this.statsCards[49].title = '0 Impression(s)';

          this.resetCardBreakdown();
          this.resetCardPixel();
        },
        getPixelLeadRecord() {
          this.isLoadingPixelLeadRecord = true;
          this.$store.dispatch('getPixelLeadRecord', {
            startDate: this.reportStartDate,
            endDate: this.reportEndDate,
            companyrootid: this.selects.rootSelected,
          })
          .then(response => {
            // console.log(response)
            this.isLoadingPixelLeadRecord = false;

            // all visitor
            if (typeof(response.pixelAllVisitor) != 'undefined') {
              const pixelAllVisitor = response.pixelAllVisitor;
              const pixelAllVisitorAllCountry = typeof(pixelAllVisitor.all_country) != 'undefined' ? pixelAllVisitor.all_country : {};
              const pixelAllVisitorUsCountry = typeof(pixelAllVisitor.us_country) != 'undefined' ? pixelAllVisitor.us_country : {};
              const pixelAllVisitorNonUsCountry = typeof(pixelAllVisitor.non_us_country) != 'undefined' ? pixelAllVisitor.non_us_country : {};

              // all regional
              this.statsCardPixel[0].data['all_country'].running = typeof(pixelAllVisitorAllCountry.running) != 'undefined' ? pixelAllVisitorAllCountry.running : 0;
              this.statsCardPixel[0].data['all_country'].stopped = typeof(pixelAllVisitorAllCountry.stopped) != 'undefined' ? pixelAllVisitorAllCountry.stopped : 0;
              this.statsCardPixel[0].data['all_country'].paused = typeof(pixelAllVisitorAllCountry.paused) != 'undefined' ? pixelAllVisitorAllCountry.paused : 0;
              this.statsCardPixel[0].data['all_country'].paused_run = typeof(pixelAllVisitorAllCountry.paused_run) != 'undefined' ? pixelAllVisitorAllCountry.paused_run : 0;
              this.statsCardPixel[0].data['all_country'].total_all = typeof(pixelAllVisitorAllCountry.total_all) != 'undefined' ? pixelAllVisitorAllCountry.total_all : 0;

              // us regional
              this.statsCardPixel[0].data['us_country'].running = typeof(pixelAllVisitorUsCountry.running) != 'undefined' ? pixelAllVisitorUsCountry.running : 0;
              this.statsCardPixel[0].data['us_country'].stopped = typeof(pixelAllVisitorUsCountry.stopped) != 'undefined' ? pixelAllVisitorUsCountry.stopped : 0;
              this.statsCardPixel[0].data['us_country'].paused = typeof(pixelAllVisitorUsCountry.paused) != 'undefined' ? pixelAllVisitorUsCountry.paused : 0;
              this.statsCardPixel[0].data['us_country'].paused_run = typeof(pixelAllVisitorUsCountry.paused_run) != 'undefined' ? pixelAllVisitorUsCountry.paused_run : 0;
              this.statsCardPixel[0].data['us_country'].total_all = typeof(pixelAllVisitorUsCountry.total_all) != 'undefined' ? pixelAllVisitorUsCountry.total_all : 0;

              // non us regional
              this.statsCardPixel[0].data['non_us_country'].running = typeof(pixelAllVisitorNonUsCountry.running) != 'undefined' ? pixelAllVisitorNonUsCountry.running : 0;
              this.statsCardPixel[0].data['non_us_country'].stopped = typeof(pixelAllVisitorNonUsCountry.stopped) != 'undefined' ? pixelAllVisitorNonUsCountry.stopped : 0;
              this.statsCardPixel[0].data['non_us_country'].paused = typeof(pixelAllVisitorNonUsCountry.paused) != 'undefined' ? pixelAllVisitorNonUsCountry.paused : 0;
              this.statsCardPixel[0].data['non_us_country'].paused_run = typeof(pixelAllVisitorNonUsCountry.paused_run) != 'undefined' ? pixelAllVisitorNonUsCountry.paused_run : 0;
              this.statsCardPixel[0].data['non_us_country'].total_all = typeof(pixelAllVisitorNonUsCountry.total_all) != 'undefined' ? pixelAllVisitorNonUsCountry.total_all : 0;
              
              // title
              this.statsCardPixel[0].title = `${this.statsCardPixel[0].data['all_country'].total_all} Visitor(s)`;
            }

            // unique visitor
            if (typeof(response.pixelAllVisitor) != 'undefined') {
              const pixelUniqueVisitor = response.pixelUniqueVisitor;
              const pixelUniqueVisitorAllCountry = typeof(pixelUniqueVisitor.all_country) != 'undefined' ? pixelUniqueVisitor.all_country : {};
              const pixelUniqueVisitorUsCountry = typeof(pixelUniqueVisitor.us_country) != 'undefined' ? pixelUniqueVisitor.us_country : {};
              const pixelUniqueVisitorNonUsCountry = typeof(pixelUniqueVisitor.non_us_country) != 'undefined' ? pixelUniqueVisitor.non_us_country : {};

              // all regional
              this.statsCardPixel[1].data['all_country'].running = typeof(pixelUniqueVisitorAllCountry.running) != 'undefined' ? pixelUniqueVisitorAllCountry.running : 0;
              this.statsCardPixel[1].data['all_country'].stopped = typeof(pixelUniqueVisitorAllCountry.stopped) != 'undefined' ? pixelUniqueVisitorAllCountry.stopped : 0;
              this.statsCardPixel[1].data['all_country'].paused = typeof(pixelUniqueVisitorAllCountry.paused) != 'undefined' ? pixelUniqueVisitorAllCountry.paused : 0;
              this.statsCardPixel[1].data['all_country'].paused_run = typeof(pixelUniqueVisitorAllCountry.paused_run) != 'undefined' ? pixelUniqueVisitorAllCountry.paused_run : 0;
              this.statsCardPixel[1].data['all_country'].total_all = typeof(pixelUniqueVisitorAllCountry.total_all) != 'undefined' ? pixelUniqueVisitorAllCountry.total_all : 0;

              // us regional
              this.statsCardPixel[1].data['us_country'].running = typeof(pixelUniqueVisitorUsCountry.running) != 'undefined' ? pixelUniqueVisitorUsCountry.running : 0;
              this.statsCardPixel[1].data['us_country'].stopped = typeof(pixelUniqueVisitorUsCountry.stopped) != 'undefined' ? pixelUniqueVisitorUsCountry.stopped : 0;
              this.statsCardPixel[1].data['us_country'].paused = typeof(pixelUniqueVisitorUsCountry.paused) != 'undefined' ? pixelUniqueVisitorUsCountry.paused : 0;
              this.statsCardPixel[1].data['us_country'].paused_run = typeof(pixelUniqueVisitorUsCountry.paused_run) != 'undefined' ? pixelUniqueVisitorUsCountry.paused_run : 0;
              this.statsCardPixel[1].data['us_country'].total_all = typeof(pixelUniqueVisitorUsCountry.total_all) != 'undefined' ? pixelUniqueVisitorUsCountry.total_all : 0;

              // non us regional
              this.statsCardPixel[1].data['non_us_country'].running = typeof(pixelUniqueVisitorNonUsCountry.running) != 'undefined' ? pixelUniqueVisitorNonUsCountry.running : 0;
              this.statsCardPixel[1].data['non_us_country'].stopped = typeof(pixelUniqueVisitorNonUsCountry.stopped) != 'undefined' ? pixelUniqueVisitorNonUsCountry.stopped : 0;
              this.statsCardPixel[1].data['non_us_country'].paused = typeof(pixelUniqueVisitorNonUsCountry.paused) != 'undefined' ? pixelUniqueVisitorNonUsCountry.paused : 0;
              this.statsCardPixel[1].data['non_us_country'].paused_run = typeof(pixelUniqueVisitorNonUsCountry.paused_run) != 'undefined' ? pixelUniqueVisitorNonUsCountry.paused_run : 0;
              this.statsCardPixel[1].data['non_us_country'].total_all = typeof(pixelUniqueVisitorNonUsCountry.total_all) != 'undefined' ? pixelUniqueVisitorNonUsCountry.total_all : 0;

              // title
              this.statsCardPixel[1].title = `${this.statsCardPixel[1].data['all_country'].total_all} Visitor(s)`;
            }

            // empty visitor
            if (typeof(response.countPixelEmptyVisitor) != 'undefined') {
              const countPixelEmptyVisitor = response.countPixelEmptyVisitor;
              const countPixelEmptyVisitorAllCountry = typeof(countPixelEmptyVisitor.all_country) != 'undefined' ? countPixelEmptyVisitor.all_country : {};
              const countPixelEmptyVisitorUsCountry = typeof(countPixelEmptyVisitor.us_country) != 'undefined' ? countPixelEmptyVisitor.us_country : {};
              const countPixelEmptyVisitorNonUsCountry = typeof(countPixelEmptyVisitor.non_us_country) != 'undefined' ? countPixelEmptyVisitor.non_us_country : {};

              // all regional
              this.statsCardPixel[2].data['all_country'].total = typeof(countPixelEmptyVisitorAllCountry.total) != 'undefined' ? countPixelEmptyVisitorAllCountry.total : 0;
              // us regional
              this.statsCardPixel[2].data['us_country'].total = typeof(countPixelEmptyVisitorUsCountry.total) != 'undefined' ? countPixelEmptyVisitorUsCountry.total : 0;
              // non us regional
              this.statsCardPixel[2].data['non_us_country'].total = typeof(countPixelEmptyVisitorNonUsCountry.total) != 'undefined' ? countPixelEmptyVisitorNonUsCountry.total : 0;
              // title
              this.statsCardPixel[2].title = `${this.statsCardPixel[2].data['all_country'].total} Visitor(s)`;
            }

            // feedback visitor
            if (typeof(response.countPixelFeedbackVisitor) != 'undefined') {
              const countPixelFeedbackVisitor = response.countPixelFeedbackVisitor;
              const countPixelFeedbackVisitorAllCountry = typeof(countPixelFeedbackVisitor.all_country) != 'undefined' ? countPixelFeedbackVisitor.all_country : {};
              const countPixelFeedbackVisitorUsCountry = typeof(countPixelFeedbackVisitor.us_country) != 'undefined' ? countPixelFeedbackVisitor.us_country : {};
              const countPixelFeedbackVisitorNonUsCountry = typeof(countPixelFeedbackVisitor.non_us_country) != 'undefined' ? countPixelFeedbackVisitor.non_us_country : {};

              // all regional
              this.statsCardPixel[3].data['all_country'].total = typeof(countPixelFeedbackVisitorAllCountry.total) != 'undefined' ? countPixelFeedbackVisitorAllCountry.total : 0;
              // us regional
              this.statsCardPixel[3].data['us_country'].total = typeof(countPixelFeedbackVisitorUsCountry.total) != 'undefined' ? countPixelFeedbackVisitorUsCountry.total : 0;
              // non us regional
              this.statsCardPixel[3].data['non_us_country'].total = typeof(countPixelFeedbackVisitorNonUsCountry.total) != 'undefined' ? countPixelFeedbackVisitorNonUsCountry.total : 0;
              // title
              this.statsCardPixel[3].title = `${this.statsCardPixel[3].data['all_country'].total} Received`;
            }

            // console.log(this.statsCardPixel);
          })
          .catch(error => {
            this.isLoadingPixelLeadRecord = false;
            console.error(error);
          })
        },
        getRootRevenue() {
          this.isLoadingRootRevenue = true;
          this.$store
              .dispatch('getRootRevenue', {
                startDate: this.reportStartDate,
                endDate: this.reportEndDate,
              })
              .then(response => {
                this.rootCards = [];
                for(var i=0; i<response.rootRevenueList.length; i++) {
                  this.rootCards.push({
                    id: i,
                    title: '$ ' + response.rootRevenueList[i].total_revenue_root,
                    subTitle: 'Total Revenue',
                    type: 'primary',
                    icon: 'fas fa-dollar-sign',
                    footer: response.rootRevenueList[i].company_name + ' Revenue',
                    showCard:true,
                  });
                }
                this.isLoadingRootRevenue = false;
              })
              .catch(error => {
                this.isLoadingRootRevenue = false;
                console.log(error);
              })
        },
        getReportAnalytics() {
            this.getRootRevenue();
            this.getPixelLeadRecord();

            this.isLoadingReportAnalytics = true;
            this.resetCardValue();
            this.$store.dispatch('getReportAnalytics', {
                startDate: this.reportStartDate,
                endDate: this.reportEndDate,
                companyid: this.activeCompanyID,
                campaignid: this.activeCampaignID,
                companyrootid: this.selects.rootSelected,
            }).then(response => {
              if (response.data.length > 0) {
                var total_pixelfire = 0;
                var total_postal = 0;
                var total_endato = 0;
                var total_md5 = 0;
                var total_bigbdm_md5 = 0;
                var total_bigbdm_pii = 0;
                var total_wattdata_md5 = 0;
                var total_wattdata_pii = 0;
                var total_wattdata = 0;
                var total_zerobouncefailed = 0;
                var zerobounce_details = {
                  valid: 0,
                  invalid: 0,
                  catch_all: 0,
                  unknown: 0,
                  spamtrap: 0,
                  abuse: 0,
                  do_not_mail: 0,
                  total: 0,
              };
                var truelist_details = {
                  total: 0,
                  ok: 0,
                  email_invalid: 0,
                  risky: 0,
                  unknown: 0,
                  accept_all: 0,
                };
                var total_locationlockfailed = 0;

                var total_bigbdm_hems = 0;
                var total_bigbdm_total_leads = 0;
                var total_bigbdm_remaining_leads = 0;
                
                var total_bigbdm_hems_b2b = 0;
                var total_bigbdm_total_leads_b2b = 0;
                var total_bigbdm_remaining_leads_b2b = 0;

                var total_failed_get_data_all = 0;
                var total_failed_get_data_bigbdmmd5 = 0;
                var total_failed_get_data_gettowerdata = 0;
                var total_failed_get_data_bigbdmpii = 0;
                var total_failed_get_data_wattdatamd5 = 0;
                var total_failed_get_data_wattdatapii = 0;

                var total_siteid_serve = 0;
                var total_siteid_serve_bigdbm = 0;
                var total_siteid_serve_wattdata = 0;
                var total_siteid_serve_bigdbm_local = 0;
                var total_siteid_serve_wattdata_local = 0;
                var total_siteid_bigdbm_identified = 0;
                var total_siteid_wattdata_identified = 0;
                var total_siteid_bigdbm_local_identified = 0;
                var total_siteid_wattdata_local_identified = 0;
                var total_searchid_serve = 0;
                var total_enhanceid_serve = 0;
                var total_enhanceid_serve_bigdbm = 0;
                var total_enhanceid_serve_wattdata = 0;
                var total_enhanceid_serve_bigdbm_local = 0;
                var total_enhanceid_serve_wattdata_local = 0;
                var total_enhanceid_bigdbm_identified = 0;
                var total_enhanceid_wattdata_identified = 0;
                var total_enhanceid_bigdbm_local_identified = 0;
                var total_enhanceid_wattdata_local_identified = 0;
                var total_b2bid_serve = 0;

                var total_platformfee_siteid_serve = 0;
                var total_platformfee_searchid_serve = 0;
                var total_platformfee_enhanceid_serve = 0;
                var total_platformfee_b2bid_serve = 0;
                
                var total_siteid_active = 0;
                var total_searchid_active = 0;
                var total_enhanceid_active = 0;
                var total_b2bid_active = 0;
                var total_simplifi_active = 0;
                var total_platformfee_simplifi = 0;
                var total_simplifi_impressions = 0;

                for(var i=0;i<response.data.length;i++) {
                  total_pixelfire = parseFloat(total_pixelfire) + parseFloat(response.data[i].pixelfire);
                  total_postal = parseFloat(total_postal) + parseFloat(response.data[i].towerpostal);
                  total_endato = parseFloat(total_endato) + parseFloat(response.data[i].endatoenrichment);
                  total_md5 = parseFloat(total_md5) +  parseFloat(response.data[i].toweremail);
                  total_bigbdm_md5 = parseFloat(total_bigbdm_md5) + parseFloat(response.data[i].bigbdmemail);
                  total_bigbdm_pii = parseFloat(total_bigbdm_pii) + parseFloat(response.data[i].bigbdmpii);
                  total_wattdata_md5 = parseFloat(total_wattdata_md5) + parseFloat(response.data[i].wattdatamd5 || 0);
                  total_wattdata_pii = parseFloat(total_wattdata_pii) + parseFloat(response.data[i].wattdatapii || 0);
                  total_zerobouncefailed = parseFloat(total_zerobouncefailed) + parseFloat(response.data[i].zerobouncefailed);

                  const current_zb_details = response.data[i].zerobounce_details;
                  if (current_zb_details) {
                      zerobounce_details.valid      += parseFloat(current_zb_details.valid || 0);
                      zerobounce_details.invalid    += parseFloat(current_zb_details.invalid || 0);
                      zerobounce_details.catch_all  += parseFloat(current_zb_details.catch_all || 0);
                      zerobounce_details.unknown    += parseFloat(current_zb_details.unknown || 0);
                      zerobounce_details.spamtrap   += parseFloat(current_zb_details.spamtrap || 0);
                      zerobounce_details.abuse      += parseFloat(current_zb_details.abuse || 0);
                      zerobounce_details.do_not_mail+= parseFloat(current_zb_details.do_not_mail || 0);
                      zerobounce_details.total      += parseFloat(current_zb_details.total || 0);
                  }

                  const current_tl_details = response.data[i].truelist_details;
                  if (current_tl_details && typeof current_tl_details === 'object') {
                      for (const key in current_tl_details) {
                          if (!truelist_details.hasOwnProperty(key)) {
                              truelist_details[key] = 0;
                          }
                          truelist_details[key] += parseFloat(current_tl_details[key] || 0);
                      }
                  }


                  total_locationlockfailed = parseFloat(total_locationlockfailed) + parseFloat(response.data[i].locationlockfailed);

                  // total_bigbdm_hems = parseFloat(total_bigbdm_hems) + parseFloat(response.data[i].bigbdmhems);
                  // total_bigbdm_total_leads = parseFloat(total_bigbdm_total_leads) + parseFloat(response.data[i].bigbdmtotalleads);
                  // total_bigbdm_remaining_leads = parseFloat(total_bigbdm_remaining_leads) + parseFloat(response.data[i].bigbdmremainingleads);

                  total_failed_get_data_all = parseFloat(total_failed_get_data_all) + parseFloat(response.data[i].getleadfailed);
                  total_failed_get_data_bigbdmmd5 = parseFloat(total_failed_get_data_bigbdmmd5) + parseFloat(response.data[i].getleadfailed_bigbdmmd5);
                  total_failed_get_data_gettowerdata = parseFloat(total_failed_get_data_gettowerdata) + parseFloat(response.data[i].getleadfailed_gettowerdata);
                  total_failed_get_data_bigbdmpii = parseFloat(total_failed_get_data_bigbdmpii) + parseFloat(response.data[i].getleadfailed_bigbdmpii);
                  total_failed_get_data_wattdatamd5 = parseFloat(total_failed_get_data_wattdatamd5) + parseFloat(response.data[i].getleadfailed_wattdatamd5 || 0);
                  total_failed_get_data_wattdatapii = parseFloat(total_failed_get_data_wattdatapii) + parseFloat(response.data[i].getleadfailed_wattdatapii || 0);

                  if (response.data[i].leadspeek_type == 'local') {
                     total_siteid_serve = response.data[i].serveclient;
                     total_siteid_serve_bigdbm = response.data[i].serveclient_bigdbm || 0;
                     total_siteid_serve_wattdata = response.data[i].serveclient_wattdata || 0;
                     total_siteid_serve_bigdbm_local = response.data[i].serveclient_bigdbm_local || 0;
                     total_siteid_serve_wattdata_local = response.data[i].serveclient_wattdata_local || 0;
                     total_siteid_bigdbm_identified = response.data[i].bigdbm_identified || 0;
                     total_siteid_wattdata_identified = response.data[i].wattdata_identified || 0;
                     total_siteid_bigdbm_local_identified = response.data[i].bigdbm_local_identified || 0;
                     total_siteid_wattdata_local_identified = response.data[i].wattdata_local_identified || 0;
                     total_platformfee_siteid_serve = response.data[i].platformfee;
                     total_siteid_active = response.data[i].activecampaign;
                  }else if (response.data[i].leadspeek_type == 'locator') {
                     total_searchid_serve = response.data[i].serveclient;
                     total_platformfee_searchid_serve = response.data[i].platformfee;
                     total_searchid_active = response.data[i].activecampaign;
                  }else if(response.data[i].leadspeek_type == 'enhance') {
                    total_enhanceid_serve = response.data[i].serveclient;
                    total_enhanceid_serve_bigdbm = response.data[i].serveclient_bigdbm || 0;
                    total_enhanceid_serve_wattdata = response.data[i].serveclient_wattdata || 0;
                    total_enhanceid_serve_bigdbm_local = response.data[i].serveclient_bigdbm_local || 0;
                    total_enhanceid_serve_wattdata_local = response.data[i].serveclient_wattdata_local || 0;
                    total_enhanceid_bigdbm_identified = response.data[i].bigdbm_identified || 0;
                    total_enhanceid_wattdata_identified = response.data[i].wattdata_identified || 0;
                    total_enhanceid_bigdbm_local_identified = response.data[i].bigdbm_local_identified || 0;
                    total_enhanceid_wattdata_local_identified = response.data[i].wattdata_local_identified || 0;
                    total_platformfee_enhanceid_serve = response.data[i].platformfee;
                    total_enhanceid_active = response.data[i].activecampaign;

                    total_bigbdm_hems = parseFloat(total_bigbdm_hems) + parseFloat(response.data[i].bigbdmhems);
                    total_bigbdm_total_leads = parseFloat(total_bigbdm_total_leads) + parseFloat(response.data[i].bigbdmtotalleads);
                    total_bigbdm_remaining_leads = parseFloat(total_bigbdm_remaining_leads) + parseFloat(response.data[i].bigbdmremainingleads);
                  }else if(response.data[i].leadspeek_type == 'b2b') {
                    total_b2bid_serve = response.data[i].serveclient;
                    total_platformfee_b2bid_serve = response.data[i].platformfee;
                    total_b2bid_active = response.data[i].activecampaign;

                    total_bigbdm_hems_b2b = parseFloat(total_bigbdm_hems_b2b) + parseFloat(response.data[i].bigbdmhems);
                    total_bigbdm_total_leads_b2b = parseFloat(total_bigbdm_total_leads_b2b) + parseFloat(response.data[i].bigbdmtotalleads);
                    total_bigbdm_remaining_leads_b2b = parseFloat(total_bigbdm_remaining_leads_b2b) + parseFloat(response.data[i].bigbdmremainingleads);
                  }else if(response.data[i].leadspeek_type == 'simplifi') {
                    total_simplifi_active = response.data[i].activecampaign;
                    total_platformfee_simplifi = response.data[i].platformfee;
                    total_simplifi_impressions = response.data[i].simplifi_impressions || 0;
                  }
                }

                // Set total_wattdata from total_wattdata_md5 and total_wattdata_pii
                total_wattdata = total_wattdata_md5 + total_wattdata_pii;

                // Ensure all default statuses exist, set missing ones to 0
                const defaultStatuses = ['total', 'ok', 'email_invalid', 'risky', 'unknown', 'accept_all'];
                defaultStatuses.forEach(status => {
                    if (!truelist_details.hasOwnProperty(status)) {
                        truelist_details[status] = 0;
                    }
                });

                if (this.activeCampaignID != '') {
                    if (response.data[0].leadspeek_type == 'local') {
                        this.statsCards[7].showCard = true;
                        this.statsCards[8].showCard = true;
                        this.statsCards[9].showCard = true;
                        this.statsCards[10].showCard = true;
                        this.statsCards[11].showCard = true;
                        this.statsCards[12].showCard = true;
                        this.statsCards[13].showCard = true;
                        this.statsCards[14].showCard = true;
                        this.statsCards[15].showCard = false;
                        this.statsCards[16].showCard = false;
                    }else if (response.data[0].leadspeek_type == 'locator') {
                        this.statsCards[7].showCard = false;
                        this.statsCards[8].showCard = false;
                        this.statsCards[9].showCard = false;
                        this.statsCards[10].showCard = false;
                        this.statsCards[11].showCard = false;
                        this.statsCards[12].showCard = false;
                        this.statsCards[13].showCard = false;
                        this.statsCards[14].showCard = false;
                        this.statsCards[15].showCard = true;
                    }
                }
                
                this.statsCardsBreakdown[0].data[0] = zerobounce_details;
                this.statsCardsBreakdown[0].title = zerobounce_details.total + ' Email(s)';

                this.statsCardsBreakdown[1].data[0] = truelist_details;
                
                if (truelist_details.hasOwnProperty('total')) {
                    this.statsCardsBreakdown[1].title = truelist_details.total + ' Email(s)';
                } else {
                    this.statsCardsBreakdown[1].title = 'See Details';
                }

                this.statsCards[0].title = total_pixelfire + ' Fire(s)';
                this.statsCards[1].title = total_postal + ' Call(s)';
                //this.statsCards[2].title = total_endato + ' Call(s)';
                //this.statsCards[3].title = total_md5 + ' Call(s)';
                this.statsCards[2].title = total_bigbdm_md5 + ' Call(s)';
                this.statsCards[3].title = total_bigbdm_pii + ' Call(s)';
                this.statsCards[4].title = total_wattdata + ' Call(s)';
                this.statsCards[5].title = total_siteid_bigdbm_identified + ' Identified';
                this.statsCards[6].title = total_siteid_wattdata_identified + ' Identified';
                this.statsCards[7].title = total_siteid_bigdbm_local_identified + ' Identified';
                this.statsCards[8].title = total_siteid_wattdata_local_identified + ' Identified';
                this.statsCards[9].title = total_siteid_serve + ' Serve(s)';
                this.statsCards[10].title = total_siteid_serve_bigdbm + ' Serve(s)';
                this.statsCards[11].title = total_siteid_serve_wattdata + ' Serve(s)';
                this.statsCards[12].title = total_siteid_serve_bigdbm_local + ' Serve(s)';
                this.statsCards[13].title = total_siteid_serve_wattdata_local + ' Serve(s)';
                this.statsCards[14].title = '$' + total_platformfee_siteid_serve;
                this.statsCards[15].title = total_searchid_serve + ' Serve(s)';
                this.statsCards[16].title = '$' + total_platformfee_searchid_serve;
                this.statsCards[17].title = total_enhanceid_serve + ' Serve(s)';
                this.statsCards[18].title = '$' + total_platformfee_enhanceid_serve;
                this.statsCards[19].title = total_b2bid_serve + ' Serve(s)';
                this.statsCards[20].title = '$' + total_platformfee_b2bid_serve;
                this.statsCards[21].title = total_zerobouncefailed + ' Blocked';
                this.statsCards[22].title = total_locationlockfailed + ' Blocked';
                this.statsCards[23].title = total_siteid_active + ' Active';
                this.statsCards[24].title = total_searchid_active + ' Active';
                this.statsCards[25].title = total_enhanceid_active + ' Active';
                this.statsCards[26].title = total_b2bid_active + ' Active';

                this.statsCards[27].title = total_bigbdm_hems + ' Lead(s)';
                this.statsCards[28].title = total_bigbdm_total_leads + ' Lead(s)';
                this.statsCards[29].title = total_enhanceid_bigdbm_identified + ' Identified';
                this.statsCards[30].title = total_enhanceid_serve_bigdbm + ' Serve(s)';
                this.statsCards[31].title = total_enhanceid_bigdbm_local_identified + ' Identified';
                this.statsCards[32].title = total_enhanceid_serve_bigdbm_local + ' Serve(s)';
                this.statsCards[33].title = total_enhanceid_wattdata_identified + ' Identified';
                this.statsCards[34].title = total_enhanceid_serve_wattdata + ' Serve(s)';
                this.statsCards[35].title = total_enhanceid_wattdata_local_identified + ' Identified';
                this.statsCards[36].title = total_enhanceid_serve_wattdata_local + ' Serve(s)';
                this.statsCards[37].title = total_bigbdm_remaining_leads + ' Lead(s)';

                this.statsCards[38].title = total_bigbdm_hems_b2b + ' Lead(s)';
                this.statsCards[39].title = total_bigbdm_total_leads_b2b + ' Lead(s)';
                this.statsCards[40].title = total_bigbdm_remaining_leads_b2b + ' Lead(s)';

                this.statsCards[41].title = total_failed_get_data_all + ' Failed';
                this.statsCards[42].title = total_failed_get_data_bigbdmmd5 + ' Failed';
                this.statsCards[43].title = total_failed_get_data_gettowerdata + ' Failed';
                this.statsCards[44].title = total_failed_get_data_bigbdmpii + ' Failed';
                this.statsCards[45].title = total_failed_get_data_wattdatamd5 + ' Failed';
                this.statsCards[46].title = total_failed_get_data_wattdatapii + ' Failed';

                this.statsCards[47].title = total_simplifi_active + ' Active';
                this.statsCards[48].title = '$' + total_platformfee_simplifi;
                this.statsCards[49].title = total_simplifi_impressions + ' Impression(s)';

              }else{
                this.statsCardsBreakdown[1].data[0] = { 
                  total: 0,
                  ok: 0,
                  email_invalid: 0,
                  risky: 0,
                  unknown: 0,
                  accept_all: 0,
                };
                this.statsCardsBreakdown[1].title = '0 Email(s)';
              }
              this.isLoadingReportAnalytics = false;
            },error => {
              this.isLoadingReportAnalytics = false;
            });
        },
        currentDate() {
          const current = new Date();
          var _month = current.getMonth()+1;
          var _year = current.getFullYear();
          var _date = current.getDate();

          _month = ('0' + _month).slice(-2);
          _date = ('0' + _date).slice(-2);

          const date = `${current.getFullYear()}-${_month}-${_date}`;
          return date;
        },
        colorApiDeveloper(row){  
          if (row.api_mode === 'T' && row.is_marketing_services_agreement_developer == 'F') {
            return 'orange';
          } else if(row.api_mode === 'T' && row.is_user_generate_api) {
            return 'green'
          } else if (row.api_mode === 'T') {
            return 'blue'
          } else if(row.is_user_generate_api) {
            return 'orange'
          } else {
            return 'gray'
          }
        },
        tooltipApiDeveloper(row){
          if (row.api_mode === 'T' && row.is_marketing_services_agreement_developer == 'F') {
            return 'The developer menu is enabled, but service agreement and payment are not completed.';
          } else if (row.api_mode === 'T' && row.is_user_generate_api) {
            return 'Both the developer menu and API key are active. All API features are available.';
          } else if (row.api_mode === 'T') {
            return 'The developer menu is enabled, but no API key has been generated.';
          } else if (row.is_user_generate_api) {
            return 'An API key has been generated, but the developer menu is still disabled.';
          } else {
            return 'API access is currently inactive. Neither the developer menu nor the API key is enabled.';
          }
        },
    },
    mounted() {
        const userData = this.$store.getters.userData;
        if (this.$global.globalviewmode && typeof(this.$route.query.campaignid) != 'undefined') {
          this.activeCompanyID = userData.company_id;
          this.activeCampaignID = this.$route.query.campaignid;
          this.statsCards[4].showCard = false;
          this.statsCards[5].showCard = false;
          this.statsCards[6].showCard = false;
          this.statsCards[7].showCard = false;
          this.statsCards[8].showCard = false;
          this.statsCards[9].showCard = false;
          this.statsCards[10].showCard = false;
          this.statsCards[11].showCard = false;
          this.statsCards[12].showCard = false;
          this.statsCards[13].showCard = false;
          this.statsCards[14].showCard = false;
          
          this.statsCardsBreakdown[0].showCard = false;
        }else if (this.$global.globalviewmode && typeof(this.$route.query.campaignid) == 'undefined') {
          this.activeCompanyID = userData.company_id;
          this.activeCampaignID = "";
        }else{
          this.activeCompanyID = "";
          this.activeCampaignID = "";
        }
        this.reportStartDate = this.currentDate();
        this.reportEndDate = this.currentDate();
        this.agencySelectedDate = this.currentDate();
        this.getRootList();
        //this.getReportAnalytics();
    },
};

</script>
<style>
.report-table .el-table__fixed{
  background: var(--background-color-secondary);
}
.report-table .el-table__fixed-right::before, .el-table__fixed::before {
  background-color: var(--background-color-secondary);
}
.report-table .el-table__body tr.hover-row>td {
  background-color: var(--table-hover-color);
}
.report-switch-tab{
  display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    padding: 25px;
    border-radius: 12px;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    flex-grow: 1;
    border: 1px solid var(--accent-color);
   
}
.report-switch-tab.--active {
  background: var(--btn-primary-color);
  color: var(--text-btn-black);
}
.under-performing-campaigns .el-table table {
color: black !important;
}
.under-performing-campaigns .el-table__fixed{
  background: #ffffff;
}

.container__input__report__analytics {
  width: 30%;
}

.container__input__filter__report__analytics {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
  gap: 16px;
}

.container__filter__report__analytics {
  display: flex;
  align-items: flex-end;
  gap: 16px;
}


.input__report__analytics .el-input__inner {
    padding-left: 30px;
    padding-right: 30px;
}

.select__company__agency__report .el-input__inner {
  border-radius: 0.4285rem;
}

.under_performing_campaign {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

@media (max-width: 992px) {
  .container__input__report__analytics {
    width: 100%;
  }
  .container__input__filter__report__analytics {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .container__filter__report__analytics {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
  .container__button__filter__report__analytics {
    width: 100%;
  }
  .button__filter__report__analytics {
    width: 100%;
  }
  .container__date__report__analytics {
    width: 100%;
  }
  .container__button__export__data {
    width: 100%;
  }
  .button__export__data {
    width: 100%;
  }
  .container__select__company__agency__report {
    width: 100%;
  }
  .select__company__agency__report {
    width: 100%;
  }
  .container_filter_default_report_analytics {
    width: 93vw !important;
    padding: 5px;
  }
  .button_download_data {
    width: 94vw !important;
    margin-left: 0px !important;
  }
  .button_download_unserved {
    width: 94vw !important;
    margin-left: 0px !important;
  }
  .select_date_container {
    margin-left: 0px !important;
  }
  .select_date_sub_container {
    margin-left: 0px !important;
  }
}
</style>